import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import PartnerAccountTransactions from './PartnerAccountTransactions';
import PartnerAccountTransfers from './PartnerAccountTransfers';
import { usePermissions } from '../../providers/Permissions.provider';

// comment no issue
const Routes = (): React.JSX.Element => {
  const { permissions } = usePermissions();
  return (
    <Switch>
      <Route exact path="/partner-account-transactions">
        <PartnerAccountTransactions />
      </Route>
      <ProtectedRoute
        isAllowed={!!permissions.AccountTransfersEnabled}
        showPermission
        exact
        path="/partner-account-transfers"
        component={PartnerAccountTransfers}
      />
    </Switch>
  );
};

export default Routes;
